export function PhotoGuide({
  guideUrl,
  orientation,
}: {
  guideUrl: string;
  orientation: "landscape" | "portrait";
}) {
  const aspect = orientation === "landscape" ? "aspect-video" : "aspect-[3/4]";
  return (
    <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
      <div
        className={`${aspect} mx-6 my-24 flex max-h-[70%] max-w-[88%] items-center justify-center`}
      >
        <img
          src={guideUrl}
          alt=""
          aria-hidden
          className="size-full object-contain mix-blend-screen opacity-70"
          style={{
            filter: "drop-shadow(0 0 6px rgba(0,0,0,0.4))",
          }}
        />
      </div>
    </div>
  );
}
